import React, { useContext} from 'react'
import { Helmet } from 'react-helmet'
import { Grid } from '@mui/material'

import './ProjectPage.css'
import { SingleProject,Navbar,Footer,SimpleHeader } from '../../components';
import { ThemeContext } from '../../contexts/ThemeContext';
import { projectsData } from '../../data/projectsData'
import { headerData } from '../../data/headerData'

function ProjectPage() {

    const { theme } = useContext(ThemeContext);

    const items = ['1', '2', '3', '4'];

    function emptyProjects(title, button, origin) {
            return (
                <>
                {items.map((item, index) => (
                    <SingleProject
                        theme={theme}
                        name='empty'
                        index={item}
                        id={item}
                        key={item}
                        title={title}  
                        button={button}
                        origin={origin}
                    />
                ))}
                </>
            );
    }   
    
    return (
        <div className="projectPage" style={{backgroundColor: theme.primary}}>
            <Helmet>
                <title>{headerData.name} | Portfolio</title>
            </Helmet>
            <Navbar />
            <SimpleHeader />
            <div className="empties" id="emptiesbefore" style={{backgroundColor: theme.primary}}>
                        <div className="empties--body">
                            <div className="empties--bodyContainer">
                                {emptyProjects('Portfolio','none','project')}
                            </div> 
                        </div>
                    </div>
            <div className="projectPage-container">
               {projectsData.map(project => (
                        <SingleProject
                            theme={theme}
                            key={project.id}
                            id={project.id}
                            name={project.projectName}
                            desc={project.projectDesc}
                            tags={project.tags}
                            code={project.code}
                            url={project.url}
                            image={project.image}
                            origin='project' 
                        />
                    ))}
           </div>
            <div className="empties" id="emptiesafter" style=   {{backgroundColor: theme.primary}}>
                <div className="empties--body">
                    <div className="empties--bodyContainer">
                        {emptyProjects('none','none','project')}
                    </div> 
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ProjectPage
